import {
    Component,
    ElementRef, EventEmitter,
    Input,
    OnInit, Output,
    ViewChild, ViewEncapsulation,
} from '@angular/core';

import {FormControl} from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {map, startWith} from 'rxjs/operators';

import {MatAutocomplete, MatChipInputEvent} from '@angular/material';
import {Observable} from 'rxjs';
import {Grievance} from '../../_services/_modals/grievance.modal';
import {GrievanceService} from '../../_services/grievance.service';
import {AppEventService} from '../../../common/_services/event-broadcaster.service';
import {GrievanceListComponent} from '../grievance-list/grievance-list.component';
import {ToastrService} from 'ngx-toastr';
import {MainComponent} from '../main/main.component';
import {HttpService} from '../../../common/_services/http.service';
import {ConfirmBoxComponent} from '../../_dialog_box/confirm-box/confirm-box.component';
import {MatDialog} from '@angular/material';
import {AppChannelComponent} from '../app-channel/app-channel.component';



@Component({
    selector: 'app-grievance',
    templateUrl: './grievance.component.html',
    styleUrls: ['./grievance.component.css'],
    encapsulation: ViewEncapsulation.None

})
export class GrievanceComponent implements OnInit {
    collapsed = false;
    @Input()
    rejectionReason: any;
    @Input()
    ai_id: number;
    @Input()
    item1: Grievance;
    @Input()
    mod_callerid: string;
    @Input()
    grivance_id: string;
    @Input()
    itemsCount: any;
    perms: any;

    is_screen_block = false;
    selectable = true;
    removable = true;
    addOnBlur = true;
    mlTranscription: string;
    mlTags: string;
    selectedmisc: boolean;
    tagCtrl = new FormControl();
    filteredTag: Observable<string[]>;
    tags = [];
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    publishType: string;
    response = [] as any;
    guidance_call_attempt = false;
    misc_local = {};
    followUp: boolean;
    resolved: boolean;
    mltranscriptCopied = true;
    mltagsCopied = true;
    audioURL: any;
    reason_id: string;
    rankList = [];
    public old_obj = {};
    public updatable_field_keys = ['id', 'transcript', 'reason_id', 'sm_image', 'detail',
                                    'rating',  'title', 'pub_order', 'tags', 'misc', 'state', 'dm_propeties'];

    @ViewChild('tagInput') tagInput: ElementRef<HTMLInputElement>;
    @ViewChild('auto') matAutocomplete: MatAutocomplete;

    rating = 5;
    showOpt = false;

    @ViewChild('tagsInput') tagsInput: ElementRef;
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onStateUpdate: EventEmitter<any> = new EventEmitter();
    @Output() clickOutside = new EventEmitter<void>();
    constructor(private grievanceService: GrievanceService,
                private broadcastService: AppEventService,
                private elementRef: ElementRef,
                private grievanceListComponent: GrievanceListComponent,
                private appChannelComponent: AppChannelComponent,
                private toastr: ToastrService,
                private maincomponent: MainComponent,
                private httpService: HttpService,
                public dialog: MatDialog,
    ) {
        this.filteredTag = this.tagCtrl.valueChanges.pipe(
            startWith(null),
            map((tag: string | null) => tag ? this._filter(tag) : this.tags.slice()));
    }

    // tslint:disable-next-line:max-line-length
    states_UNM = [
        {id: 'PUB', name: 'Published', disabled: this.appChannelComponent.role_perms.UNM.accept_reject_tab.pub_item},
        {id: 'ARC', name: 'Archived', disabled: this.appChannelComponent.role_perms.UNM.accept_reject_tab.arc_item},
        {id: 'REJ', name: 'Rejected', disabled: this.appChannelComponent.role_perms.UNM.accept_reject_tab.rej_item}
    ];
    states_PUB = [
        {id: 'UNM', name: 'Unmoderated', disabled: this.appChannelComponent.role_perms.PUB.accept_reject_tab.unm_item},
        {id: 'ARC', name: 'Archived', disabled: this.appChannelComponent.role_perms.PUB.accept_reject_tab.arc_item},
        {id: 'REJ', name: 'Rejected', disabled: this.appChannelComponent.role_perms.PUB.accept_reject_tab.rej_item}
    ];
    states_REJ = [
        {id: 'UNM', name: 'Unmoderated', disabled: this.appChannelComponent.role_perms.REJ.accept_reject_tab.unm_item},
        {id: 'PUB', name: 'Published', disabled: this.appChannelComponent.role_perms.REJ.accept_reject_tab.pub_item},
        {id: 'ARC', name: 'Archived', disabled: this.appChannelComponent.role_perms.REJ.accept_reject_tab.arc_item}
    ];
    states_ARC = [
        {id: 'UNM', name: 'Unmoderated', disabled: this.appChannelComponent.role_perms.ARC.accept_reject_tab.unm_item},
        {id: 'PUB', name: 'Published', disabled: this.appChannelComponent.role_perms.ARC.accept_reject_tab.pub_item},
        {id: 'REJ', name: 'Rejected', disabled: this.appChannelComponent.role_perms.ARC.accept_reject_tab.rej_item}
    ];

    ngOnInit() {
        this.audioURL = this.item1.audio_url + '?T=' + Date.now();
        this.assignItemPermissions();
        this.old_obj = {};
        for (let item of this.updatable_field_keys) {
            if ((item === 'tags' || item === 'transcript' || item === 'misc') && !this.item1[item])
                this.item1[item] = '';
            this.old_obj[item] = this.item1[item];
        }
        for (let rank = 0; rank < this.itemsCount; rank++) {
            this.rankList[rank] = rank;
        }
        this.tags = this.item1.tags.split(',');
        if (this.item1.ml_properties) {
            this.mlTranscription = JSON.parse(this.item1.ml_properties)['ml_transcript'];
            this.mlTags = JSON.parse(this.item1.ml_properties)['ml_tags'].split(',');
        }
        if (this.item1.misc) {
            this.misc_local = JSON.parse(this.item1.misc);
            this.selectedmisc = this.misc_local['sync_image'];
        }
    }

    assignItemPermissions() {
        if (this.item1.state === 'PUB') {
            this.perms = this.appChannelComponent.role_perms.PUB;
        } else {
            this.perms = this.appChannelComponent.role_perms.UNM;
        }
    }

    openMLConfirmBox(value) {
        const dialogRef = this.dialog.open(ConfirmBoxComponent, {
                width: '20',
                data: {message: 'Do you want to copy?',
                       ok_text: 'Yes',
                       cancel_text: 'No',
                       ok_color: 'warn',
                       cancel_color: 'primary'}
            }
        );
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.copyML(value);
            }
        });
    }

    openRankConfirmBox(value) {
        const dialogRef = this.dialog.open(ConfirmBoxComponent, {
                width: '20',
                data: {message: 'Do you want to change rank?',
                    ok_text: 'Yes',
                    cancel_text: 'No',
                    ok_color: 'warn',
                    cancel_color: 'primary'}
            }
        );
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.itemrank(value);
            }
        });
    }

    assignTag() {
        this.item1.tags = this.tags.toString();
        if (this.followUp === true) {
            this.item1.tags = this.item1.tags + ',' + 'followUp' ;
        }
        if (this.resolved === true) {
            this.item1.tags = this.item1.tags + ',' + 'resolved' ;
        }
    }

    itemrank(value) {
        this.item1.pub_order = value;
        this.grievanceService.saveGrievance(this.item1, this.old_obj)
            .subscribe((response: any[]) => {
                this.response = response;
                if (this.response.success === 'True') {
                    this.old_obj = {};
                    for (let item of this.updatable_field_keys) {
                        if ((item === 'tags' || item === 'transcript' || item === 'misc') && !this.item1[item])
                            this.item1[item] = '';
                        this.old_obj[item] = this.item1[item];
                    }
                    this.toastr.success(this.response.success, 'Rank Changed');
                    this.maincomponent.ngOnInit();
                } else if (this.response.success === 'False') {
                    this.toastr.error(this.response.message, 'Failed');
                }

            });
    }

    imageChange(fileInput: any) {
        if (fileInput.target.files && fileInput.target.files[0]) {
            const reader = new FileReader();
            reader.onload = ((e) => {
                this.toastr.info( 'Image is uploading');
                this.httpService.uploadsm_image(this.item1.id, fileInput.target.files[0])
                    .subscribe((response: any[]) => {
                        this.response = response;
                        this.toastr.success( 'Successfully Uploaded');
                        this.item1.image_url = e.target['result'];
                        this.item1.sm_image = this.response.id ;
                    });
            });
            reader.readAsDataURL(fileInput.target.files[0]);
        }
    }

    audioChange(fileInput: any) {
        this.toastr.info( 'Wait Audio is Uploading');
        if (fileInput.target.files && fileInput.target.files[0]) {
            const reader = new FileReader();
            reader.onload = ((e) => {
                this.httpService.uploadAudio(this.item1, fileInput.target.files[0])
                    .subscribe((response: any[]) => {
                        this.response = response;
                        this.item1.audio_url = e.target['result'];
                        this.toastr.success( 'Successfully Uploaded');
                        this.item1.detail = this.response.id;
                        this.maincomponent.ngOnInit();
                    });
            });
            reader.readAsDataURL(fileInput.target.files[0]);
        }
    }

    add(event: MatChipInputEvent): void {
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            this.tags.push(value.trim());
        }
        if (input) {
            input.value = '';
        }
    }

    remove(tags): void {
        const index = this.tags.indexOf(tags);
        if (index >= 0) {
            this.tags.splice(index, 1);
        }
    }

    copyML(value) {
        if (value === 'transcript') {
            if (this.mltranscriptCopied) {
                this.item1.transcript = this.mlTranscription;
                this.mltranscriptCopied = false;
            }
        }
        if (value === 'tags') {
            if (this.mltagsCopied) {
                this.tags = this.tags.concat(this.mlTags);
                this.mltagsCopied = false;
            }
        }
    }

    showSuccess(msg, title) {
        this.toastr.success(msg, title);
    }

    guidanceCall() {
        this.guidance_call_attempt = true;
        this.grievanceService.callContributor(this.mod_callerid, this.item1.callerid).subscribe( data => {
            this.showSuccess('कॉल का प्रयास किया जा रहा है', 'Call');
        });
    }

    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.tags.filter(tag => tag.toLowerCase().indexOf(filterValue) === 0);
    }

    changeState(event) {
        this.publishType = event;
    }

    save() {
        this.item1.reason_id = this.reason_id;
        if (!this.item1.reason_id)
            this.item1.reason_id = null;
        this.assignTag();
        this.item1.state = this.publishType;
        if (this.selectedmisc)
            this.misc_local['sync_image'] = this.selectedmisc;
        else if (this.misc_local['sync_image'])
            this.misc_local['sync_image'] = this.selectedmisc;
        if (Object.keys(this.misc_local).length === 0)
            this.item1.misc = '';
        else
            this.item1.misc = JSON.stringify(this.misc_local);
        if (this.item1.dm_propeties) {
            this.item1.dm_propeties = JSON.parse(this.item1.dm_propeties);
            // tslint:disable-next-line:radix
            this.item1.dm_propeties.mod_msisdn = this.mod_callerid;
            this.item1.dm_propeties = JSON.stringify(this.item1.dm_propeties);
        } else {
            // tslint:disable-next-line:radix
            let dm_propeties = {'mod_msisdn': this.mod_callerid};
            this.item1.dm_propeties = JSON.stringify(dm_propeties);
        }
        this.grievanceService.saveGrievance(this.item1, this.old_obj)
            .subscribe((response: any[]) => {
                this.response = response;
                if (this.response.success === 'True') {
                    this.old_obj = {};
                    for (let item of this.updatable_field_keys) {
                        if ((item === 'tags' || item === 'transcript' || item === 'misc') && !this.item1[item])
                            this.item1[item] = '';
                        this.old_obj[item] = this.item1[item];
                    }
                    this.toastr.success(this.response.success, 'Item Updated');
                    this.maincomponent.ngOnInit();
                } else if (this.response.success === 'False') {
                    this.toastr.error(this.response.message, 'Item Update Failed');
                }

            });
    }
}
